import { OrganizationService, OrganizationDetailService } from '@/services/local-storage';
import api from '@/services/api';

export const state = () => ({
  organizationList: [],
  selectedOrganization: OrganizationService.get(),
  selectedOrganizationDetail: OrganizationDetailService.get(),
});

// getters
export const getters = {
  selectedOrganizationName: (state) => state.selectedOrganizationDetail.name ?? '',
  mapMedia: (state) => {
    const isMediaAvailable = !!(state.selectedOrganizationDetail?.media?.length);

    if (isMediaAvailable) {
      const mapMediaObject = state.selectedOrganizationDetail.media.find((media) => media.collection === 'map');
      return mapMediaObject ?? {};
    }
    return {};
  },
};

// actions
export const actions = {
  async getOrganizationList({ commit }) {
    try {
      const res = await api.getOrganizations();
      const organizations = res.data.data;
      commit('SET_ORGANIZATION_LIST', organizations);
    } catch (error) {
      console.log(error);
    }
  },

  async getOrganizationDetail({ commit }, organizationId) {
    try {
      const res = await api.getOrganizationDetail(organizationId);
      const organizationDetail = res.data.data;
      commit('SET_ORGANIZATION_DETAIL', organizationDetail);
    } catch (error) {
      console.log(error);
    }
  },
};

// mutations
export const mutations = {
  SET_ORGANIZATION_LIST(state, organizationListData) {
    state.organizationList = organizationListData;
  },
  SET_SELECTED_ORGANIZATION(state, selectedOrganizationData) {
    OrganizationService.set(selectedOrganizationData);
    state.selectedOrganization = selectedOrganizationData;
  },
  SET_ORGANIZATION_DETAIL(state, organizationDetailData) {
    OrganizationDetailService.set(organizationDetailData);
    state.selectedOrganizationDetail = organizationDetailData;
  },
};
